module.exports = __webpack_public_path__ + "img/Original_blue1.b917c671.svg";